import React from "react";
import { Route, Routes } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";

import MessageContainer from "../../containers/MessageContainer";
import MessageAnalysis from "./MessageAnalysis";
import Header from "../../components/Header";
import File from "./File";
import PriorityContacts from "./PriorityContacts";
import About from "./About";
import ChangesSummary from "./ChangesSummary";
import ComparisonDetail from "./ComparisonDetail";
import MessageSummary from "./MessageSummary";
import FollowedConversations from "./FollowedConversations/FollowedConversations";
import { wrapperClass } from "./styles";

import { getFollowedConversations } from "../../api/follow";
import useAuthContext from "../../hooks/useAuthContext";
import { FollowedConversationsContext } from "../../contexts/FollowedConversationsContext";
import { FilingContextProvider } from "../../contexts/FilingContext";

const AuthorizedRoutes = () => {
  const { tokenData } = useAuthContext();
  const msUserId = tokenData.oid;

  const { data, isPending, refetch } = useQuery({
    queryKey: ["conversationSummaryQuery", msUserId],
    queryFn: () => getFollowedConversations(msUserId),
    enabled: !!msUserId,
    staleTime: 0,
  });

  return (
    <div className={wrapperClass}>

      <MessageContainer>
        <FilingContextProvider>
        <FollowedConversationsContext.Provider value={{ refetchFollowedConversations: refetch }}>
          <Header />
          <Routes>
            <Route path="*" element={<MessageAnalysis />} />
            <Route path="/file" element={<File />} />
            <Route path="/priority-contacts" element={<PriorityContacts />} />
            <Route path="/pause-notification" element={<PriorityContacts />} />
            <Route path="/about" element={<About />} />
            <Route path="/messageSummary" element={<MessageSummary />} />
            <Route
              path="/followedConversations"
              element={<FollowedConversations data={data} isPending={isPending} />}
            />
            <Route path="/changes-summary/:attachmentId" element={<ChangesSummary />} />
            <Route
              path="/comparison-summary-detail/:attachmentId/:recognizedSegmentIndex/:recognizedHeadingIndex"
              element={<ComparisonDetail />}
            />
          </Routes>
        </FollowedConversationsContext.Provider>
        </FilingContextProvider>
      </MessageContainer>

    </div>
  );
};

export default AuthorizedRoutes;
